import { placeholdersToVariableNodes } from './htmlTemplateVariables';

const htmlTemplateOrganizationParser = (html: any, intl: any) => {
    if (!html || typeof html !== 'string') {
        return html;
    }

    return placeholdersToVariableNodes(html, intl);
};

const exportedObject = {
    htmlTemplateOrganizationParser
};

export default exportedObject;
